export var WiFi;
(function (WiFi) {
    let ConnectionState;
    (function (ConnectionState) {
        ConnectionState[ConnectionState["CONNECTED"] = 8] = "CONNECTED";
    })(ConnectionState = WiFi.ConnectionState || (WiFi.ConnectionState = {}));
    function isConnectedViaWiFi(state) {
        return state?.con_stat === ConnectionState.CONNECTED;
    }
    WiFi.isConnectedViaWiFi = isConnectedViaWiFi;
})(WiFi || (WiFi = {}));
